import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "My blog is the best resource online for \"60*60\"",
  "description": "",
  "published": "2016-09-27T00:00:00.000Z",
  "redirect_from": ["/blog/blog-best-resource-online-6060/swizec/7068"],
  "categories": "Learning, Personal",
  "hero": "./img/yZSIq3j.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Try it. `}<a parentName="p" {...{
        "href": "https://www.google.com/webhp?sourceid=chrome-instant&ion=1&espv=2&ie=UTF-8#q=60*60"
      }}>{`Google 60`}{`*`}{`60`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "844px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/d0a3d8a3fef297aaff56ef237c68426f/33e10/yZSIq3j.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "82.95964125560539%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'332\\'%20viewBox=\\'0%200%20400%20332\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M312%2011v10h20V2l-10-1h-10v10M10%204L5%205C2%205%202%205%202%208l-1%202-1%203c0%201%200%202%201%201%200-1%204%202%204%204l2%201c2%200%203-2%201-2v-1c2-1%202%200%202%201s1%202%203%202%202%200%202-2%201-3%202-3l1%203c0%202%202%203%202%200h1l1%202%201-2v-3l1-5c0-4%200-4-3-4-2%200-3%201-3%204l-2%202h-2l-1-4c0-4-2-6-3-3m28%204l1%206%202-1h3c0%201%201%201%202-1l2-2%202%202c1%202%201%202%203%201h2c0%202%203-1%203-3%200-3-3-4-4-2H38m23%2055l-1%202-1%201%2018%201%2018-1v-2c0-2-1-2-5-3-3%200-4%201-5%202%200%202-2%203-2%200-1-2-9-2-10%200%200%202-2%203-2%200-1-2-9-2-10%200m225%2044l-1%203%203-1h2v2c-2%200-3%202%200%202l1%201c0%202-2%202-4%201-1-1-3-1-2%201h17c2%202%206%201%206-1l2%201c2%202%205%202%206-2%202-5-3-10-6-6-2%202-2%202-3%200-2-3-5-2-6%203-1%202-1%201-1-2%200-4-6-3-7%201l-1%204v-4c0-2-1-3-2-3h-4M46%20138v9h38v-18H46v9m82%200v9h36v-18h-36v9m41%200v9h36v-18h-36v9m41%200v9h36v-18h-36v9m40-8v9l1%208h36v-17l-18-1-19%201m41%208v9h36v-18h-36v9M46%20159l1%209h35v-18H46v9m41%200v9h36v-18H87v9m41%200v9h36v-18h-36v9m163%200l1%209h35v-18h-36v9M46%20181v8h36v-17H46v9m41%200v8h36v-17H87v9m41%200v8h36v-17h-36v9m163%200v8h36v-17h-36v9M46%20202v8h36v-17H46v9m41%200v8h36v-17H87v9m41%200v8h36v-17h-36v9m163%200v8h36v-17h-36v9m-40%2012l-1%209v8h37v-17l-18-1-18%201m-205%209v8h36v-17H46v9m41%200v8h36v-17H87v9m41%200v8h36v-17h-36v9m163%200v8h36v-17h-36v9M99%20259h-3l-1%201%202%201%201%202c0%203%208%203%209%200%200-1%201-2%203-2%203-1%204%200%201%202-1%202-1%202%202%202%202%200%202%200%201-1v-1h1l4%201v-4l-1-2-1%202-2%201c0-2-2-3-3-2H99m49%200l-11%201-10%201h-1c-1-2-4-1-4%202%201%203%2019%203%2020%200l1-2v2c0%201%201%202%206%202s5%200%205-2-1-3-2-3l-3-1h-1m106%201c-1%201-1%201%201%202l2%201h-4c0%202%203%202%205%201h7l3%201c2%200%203%200%202-1v-1h1c1%202%209%202%2010%201l-1-1c-1%201-2%200-2-1h1l1-1-6-1-7-1h-2c-1%202-4%202-6%200-3-1-3-1-5%201M38%20271c0%202%200%202%201%201h1c0%201%206%203%207%202h5l3-1h11c3%201%2022%201%2022-1h3c0%202%202%203%202%201h1l5%201h11l2-1h2l5%201h3l1%201%201-1c0-2%201-2%204-1h4l2-1c2%202%2010%202%2010%201h27a94%2094%200%200026%200h5l4%201c0%202%203%201%204%200l1-1h22c1%201%205%200%206-1v-4c-1%200-2%201-1%202l-1%202v-2l-3-2-2%201h-35c0%202-2%203-3%201l-2-1h-13l-9%201c-1%202-3%201-3-1h-3c-2-1-17-1-19%201h-15c-2-2-3-2-3%200%200%201-2%202-2%200h-2l-2-1h-5c-3%202-3%202-6%200H86c-4%200-6%201-6%202l-3%201v-1c2-1%200-2-3-2H54l-1%201v2l-1-1c0-1-2-2-6-2h-7c-1-1-1%200-1%202m75%207c-1%203%204%205%207%202h2c1%202%206%202%207%200l2-1v2l2%201%204-1%201-2-2-2a936%20936%200%2001-23%201m-63%2038c0%203%203%205%204%202h1c0%202%206%201%206-1s0-2%201%200c1%203%206%203%206%200l1-2v2c0%202%200%202%205%202%206%200%206-1%205-3%200-1-1-2-4-2h-5c-2-1-4%200-4%202s0%202-1%201c0-2-1-3-2-3l-4-1c-3-1-4-1-5%201l-1%202v-2c-2-3-3-2-3%202m33-3v7h3c2%202%206%201%207-1l1-1%2010%201c10%200%2010%200%2010-2s0-2%201%200c1%203%206%203%206%200%201-2%201-2%201%200s0%202%205%202l6%201h2v-7c-2-1-2-1-1%203%200%203%200%203-1%201%200-2-1-3-5-3h-5c-1-1-3%200-3%202l-1%201-1-1c0-1-1-2-3-2l-3-1c-1-1-4-1-5%201%200%202%200%202-1%200s-1-2-2-1H83m60%201l1%203c0%203%202%202%202-1v-2l1%202c2%204%202%204%203%202h1c0%202%202%201%202-1l1%201c1%201%201%201%201-1%201-2%201-2%201%200%200%203%2011%203%2011-1%201-2%200-2-3-2h-4l-2-1h-4c-1%202-5%202-6%200l-3-1c-2%200-2%200-2%202M38%20326c0%202%200%202%201%201h1c0%201%206%203%207%202l4-1h15c2%201%208%201%209-1%202-2%201-3-2-3H54l-1%201v2l-1-1-2-2h-7c-5%200-5%200-5%202m52-2h-6c-5%200-6%201-7%202v2h15l15-1h1l8%202c5%200%206-1%206-2%200-3-8-4-10-1h-1l-2-2h-3c0-2-3-1-4%201h-1c0-2-11-3-11-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/d0a3d8a3fef297aaff56ef237c68426f/ca0a1/yZSIq3j.webp 223w", "/static/d0a3d8a3fef297aaff56ef237c68426f/75680/yZSIq3j.webp 445w", "/static/d0a3d8a3fef297aaff56ef237c68426f/20d15/yZSIq3j.webp 844w"],
              "sizes": "(max-width: 844px) 100vw, 844px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/d0a3d8a3fef297aaff56ef237c68426f/e92b6/yZSIq3j.png 223w", "/static/d0a3d8a3fef297aaff56ef237c68426f/e66bf/yZSIq3j.png 445w", "/static/d0a3d8a3fef297aaff56ef237c68426f/33e10/yZSIq3j.png 844w"],
              "sizes": "(max-width: 844px) 100vw, 844px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/d0a3d8a3fef297aaff56ef237c68426f/33e10/yZSIq3j.png",
              "alt": "yZSIq3j",
              "title": "yZSIq3j",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`First you get the calculator, then you get my blog where I bitch about programming time stuff. Wat.`}</p>
    <p>{`Out of all the other websites on the internet, Google has decided that my blog is the single best resource possible to learn about “60`}{`*`}{`60”. I… thanks?`}</p>
    <p>{`The experiment even reproduces! I googled incognito, I had my friends google it, I even googled on my girlfriend’s laptop to make sure it’s not a programmer thing. Swizec.com is first result. It’s the best thing out there.`}</p>
    <p>{`Better even than `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/60x60"
      }}>{`wikipedia’s page titled 60x60`}</a>{`. Or the `}<em parentName="p">{`60 Minutes`}</em>{` account on Twitter.`}</p>
    <p>{`If you wanna learn about 60`}{`*`}{`60, come to my site. I gotchu, fam. Apparently …`}</p>
    <h3 {...{
      "id": "doing-the-seo"
    }}>{`Doing the SEO`}</h3>
    <p>{`I have no idea how Google decided I’m an expert on multiplying 60 by 60, but I can tell you this: I don’t know how SEO works. It sounds like black magic to me.`}</p>
    <p>{`My search engine optimization strategy goes like this:`}</p>
    <ol>
      <li parentName="ol">{`Publish stuff`}</li>
      <li parentName="ol">{`Avoid fanciness, make site readable (i.e. use Wordpress)`}</li>
      <li parentName="ol">{`???`}</li>
      <li parentName="ol">{`60% organic search traffic`}</li>
    </ol>
    <p>{`Maybe this is a strategy that works. Maybe I got lucky. Maybe it’s because my blog has been alive for 10 years. Maybe it works because I keep posting. Maybe all of that.`}</p>
    <p>{`¯`}{`\\`}{`_`}{`(ツ)`}{`_`}{`/¯`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "425px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/f33d571b41c41924e83b57e23ed61d4c/2fbbf/JzmiLpw.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "62.33183856502242%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'249\\'%20viewBox=\\'0%200%20400%20249\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M140%2071l-1%201%201%2011%203%2025%202%2016V97c-1-28-1-28-5-26m6%2037a311%20311%200%2001-2%2038l-36-1H71l1%204c2%2022%209%2038%2023%2050%205%205%205%205%207%203h1l-1%202c-1%201%206%206%2013%209%2029%2012%2061%206%2083-15a75%2075%200%2000-48-128h-4v38m-59-9c-9%2011-14%2025-15%2038l-1%207h73l-4-4-49-46-4%205\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/f33d571b41c41924e83b57e23ed61d4c/ca0a1/JzmiLpw.webp 223w", "/static/f33d571b41c41924e83b57e23ed61d4c/8dc4f/JzmiLpw.webp 425w"],
              "sizes": "(max-width: 425px) 100vw, 425px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/f33d571b41c41924e83b57e23ed61d4c/e92b6/JzmiLpw.png 223w", "/static/f33d571b41c41924e83b57e23ed61d4c/2fbbf/JzmiLpw.png 425w"],
              "sizes": "(max-width: 425px) 100vw, 425px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/f33d571b41c41924e83b57e23ed61d4c/2fbbf/JzmiLpw.png",
              "alt": "JzmiLpw",
              "title": "JzmiLpw",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Organic search drives 60% of my traffic, 14.7% comes from untraceable sources`}<a parentName="p" {...{
        "href": "#fn1-2164",
        "title": "see footnote"
      }}>{`1`}</a>{`, 12% social, 11% referral`}<a parentName="p" {...{
        "href": "#fn2-2164",
        "title": "see footnote"
      }}>{`2`}</a>{`, and a teeeeeeny tiiiny little sliver of email - 1.5%. That’s 490 people in the past 30 days.`}</p>
    <p>{`Like so many people from email.`}</p>
    <p>{`So why am I spending so much emotional energy on email? The weekly newsletters, the subscribe forms, the sinking feeling that every unsubscribe brings. And for what? Less than 2% of all traffic.`}</p>
    <p>{`Silly.`}</p>
    <p>{`And yet, when an email goes out, there’s an uptick in traffic, an uptick in comments, an uptick in sales. An uptick in just about everything.`}</p>
    <p>{`So what the hell is all that organic traffic doing?`}</p>
    <p>{`¯`}{`\\`}{`_`}{`(ツ)`}{`_`}{`/¯`}</p>
    <p>{`Oh, I guess my advice to you is `}<em parentName="p">{`if you want SEO, have something for people to find.`}</em>{` Nothing you do will work if there’s nothing for Google to find. SEO is a dead industry. Don’t even sweat about it. Just have good shit for people to find.`}</p>
    <hr></hr>
    <ol>
      <li parentName="ol"></li>
      <li parentName="ol">
        <p parentName="li">{`I call “direct” untraceable because it could mean a lot of things. I doubt very many people are manually going to swizec.com `}<a parentName="p" {...{
            "href": "#fnr1-2164",
            "title": "return to article"
          }}>{`↩︎`}</a></p>
      </li>
      <li parentName="ol"></li>
    </ol>
    <p>{`4)  Most likely backlinks from all those automated sites that keep stealing and republishing my content without attribution. I keep getting the pingbacks, and I keep not seeing any attribution on the pages themselves. Oh well. `}<a parentName="p" {...{
        "href": "#fnr2-2164",
        "title": "return to article"
      }}>{`↩︎`}</a></p>
    <p>{`5)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      